import {trackUserProperties} from './trackUserProperties.middleware';

export const fullStoryMiddleware = [trackUserProperties];
